import {
  getData,
  postData,
  patchData,
  deleteData,
} from "../api/api";
import type {
  CreateSourceSystemRequest,
  UpdateSourceSystemRequest,
} from "../types/incident";
import { buildReadQueryString } from "../lib/api/readQuery";
import { buildIlikeFilter } from "../lib/rsql";

const SOURCE_SYSTEM_BASE_URL = "/source-system";

const buildReadQuery = (
  page: number,
  size: number,
  search?: string,
  fields?: string | string[],
) =>
  buildReadQueryString({
    page,
    size,
    sort: "createdDate,desc",
    search,
    fields,
  });

const buildCustomerIdSearch = (customerId: string, nameSearch?: string) => {
  const filters = [`customerId=eq=${customerId}`];
  const nameFilter = buildIlikeFilter("name", nameSearch ?? "");
  if (nameFilter) {
    filters.push(nameFilter);
  }
  return filters.join(";");
};

export const sourceSystemService = {
  // GET /source-system/read — paginated list with optional RSQL search
  getSourceSystems: async (
    page: number = 0,
    size: number = 10,
    search?: string,
    fields?: string | string[],
  ) => {
    return getData(`${SOURCE_SYSTEM_BASE_URL}/read?${buildReadQuery(page, size, search, fields)}`);
  },

  // GET /source-system/read?search=customerId=eq={id}
  getSourceSystemsByCustomerId: async (
    customerId: string,
    page: number = 0,
    size: number = 100,
    nameSearch?: string,
    fields?: string | string[],
  ) => {
    const search = customerId ? buildCustomerIdSearch(customerId, nameSearch) : nameSearch;
    return getData(`${SOURCE_SYSTEM_BASE_URL}/read?${buildReadQuery(page, size, search, fields)}`);
  },

  // GET /source-system/read/{id}
  getSourceSystem: async (id: string) => {
    return getData(`${SOURCE_SYSTEM_BASE_URL}/read/${id}`);
  },

  // POST /source-system/create
  createSourceSystem: async (data: CreateSourceSystemRequest) => {
    return postData(`${SOURCE_SYSTEM_BASE_URL}/create`, data);
  },

  // PATCH /source-system/update
  updateSourceSystem: async (data: UpdateSourceSystemRequest) => {
    return patchData(`${SOURCE_SYSTEM_BASE_URL}/update`, data);
  },

  // DELETE /source-system/delete/{record_id}
  deleteSourceSystem: async (recordId: string) => {
    return deleteData(`${SOURCE_SYSTEM_BASE_URL}/delete/${recordId}`);
  },
};
